import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { SpaceInfo } from 'src/api/types';
import { Grid } from 'src/components/Grid/Grid';
import { getDeviceSize, getIsDesktop } from 'src/store/agent/selectors';
import { getSpacesState } from 'src/store/spaces/selectors';
import { fetchSpaces } from 'src/store/spaces/services';
import { useAppDispatch } from 'src/store/useAppDispatch';
import { DeviceSize } from 'src/types';

import { desktopSpaceCardHeight } from './SpaceCard/DesktopSpaceCard/consts';
import { mobileSpaceCardHeight } from './SpaceCard/MobileSpaceCard/consts';
import { SpaceCard } from './SpaceCard/SpaceCard';
import { useSpaces } from './SpacesProvider';

const Item: FC<{ data: SpaceInfo }> = ({ data }) => {
  return <SpaceCard space={data} />;
};

const twoColumnsSizes = new Set([DeviceSize.XL, DeviceSize.L, DeviceSize.M]);

export const SpacesList: FC = () => {
  const isDesktop = useSelector(getIsDesktop);
  const size = useSelector(getDeviceSize);
  const dispatch = useAppDispatch();
  const { loadMore } = useSpaces();

  const { rows, loading } = useSelector(getSpacesState);

  useEffect(() => {
    dispatch(fetchSpaces(true));
  }, [dispatch]);

  return (
    <Grid<SpaceInfo>
      columnCount={twoColumnsSizes.has(size) ? 2 : 1}
      rows={rows}
      loadMore={loadMore}
      rowHeight={isDesktop ? desktopSpaceCardHeight : mobileSpaceCardHeight}
      Item={Item}
      noResults='Пространства не найдены'
      isLoading={loading}
      loading='Загрузка пространств'
    />
  );
};
